//Models
PJQ.models.dailyReports.Settings = PJQ.models.BaseModel.extend({
	idAttribute: 'settingId',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: this.get('project').id
			},
			{
				endpoint: 'dailyReports'
			},
			{
				endpoint: 'settings'
			}
		]);
	},
	parse: function(model){
		if(model){
			if(model.templates){
				this.templates = new PJQ.collections.dailyReports.SurveyTemplates(model.templates);
			}
			else{
				this.templates = new PJQ.collections.dailyReports.SurveyTemplates();
			}

			if(model.notificationSettings){
				this.notificationSettings = new PJQ.collections.dailyReports.NotificationSettingsPerUsers(model.notificationSettings);
			}
			else{
				this.notificationSettings = new PJQ.collections.dailyReports.NotificationSettingsPerUsers();
			}
		}
		else{
			this.templates = new PJQ.collections.dailyReports.SurveyTemplates(model.templates);
			this.notificationSettings = new PJQ.collections.dailyReports.NotificationSettingsPerUsers(model.notificationSettings);
		}
		return model;
	},
	beforeSave: function(){
		this.set('templates', _.map(this.templates.models, function(template){
			return {
				"surveyTemplateId": template.id
			};
		}));
	}
});

PJQ.models.dailyReports.NotificationSettingsPerUser = PJQ.models.BaseModel.extend({
	idAttribute: 'notificationSettingsUserId'
});


//Collections
PJQ.collections.dailyReports.NotificationSettingsPerUsers = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.dailyReports.NotificationSettingsPerUser,
	addUserForDay: function(id, day) {

		// find existing NotificationSettingPerUser
		let setting = null;
		_.each(this.models, _.bind(function(model) {
			if (model.get('userId') === id)
				setting = model;
		}, this));

		if (setting) {
			setting.set('workDays', setting.get('workDays') | day);
		}
		else {
			setting = new PJQ.models.dailyReports.NotificationSettingsPerUser();
			setting.set('userId', id);
			setting.set('projectId', PJQ.app.session.project.id);
			setting.set('workDays', day);

			this.models.push(setting);
		}
	},
	removeUserFromDay: function(id, day) {

		// find existing NotificationSettingPerUser
		let setting = null;
		_.each(this.models, _.bind(function(model) {
			if (model.get('userId') === id) {
				setting = model;
			}
		}, this));

		// remove this day from its bitmask
		setting.set('workDays', setting.get('workDays') & ~day);
	},
	getContactsForDay: function(day) {
		let contacts = [];
		_.each(this.models, _.bind(function(model) {
			if ((model.get('workDays') & day) === day) {
				let contact = new PJQ.models.BaseModel();
				contact.set('id', model.get('userId'));
				contact.set('companyName', model.get('companyName'));
				contact.set('contactName', model.get('contactName'));
				contacts.push(contact);
			}
		}, this));
		return contacts;
	}
});
